import { Segment as SemanticSegment } from 'semantic-ui-react';

export { SegmentProps, StrictSegmentProps } from 'semantic-ui-react';

export const Segment: typeof SemanticSegment = SemanticSegment;

export default Segment;
